import { useMissionsTranslation } from '../../../../../../../../ui/hooks';
import { Alert } from '@mui/material';
import React from 'react';
export const ParticipationsStatusAlert = ({ oigFailed, denied, multiplePositions }) => {
    const { t, i18n } = useMissionsTranslation();
    const statuses = [];
    if (oigFailed) {
        statuses.push(t('shifts.pendingRequest.review.alert.oigFailed').toLowerCase());
    }
    if (denied) {
        statuses.push(t('shifts.pendingRequest.review.alert.denied').toLowerCase());
    }
    if (multiplePositions) {
        statuses.push(t('shifts.pendingRequest.review.alert.multiplePositions').toLowerCase());
    }
    const formattedStatuses = new Intl.ListFormat(i18n.language, {
        style: 'short',
        type: 'disjunction',
    }).format(statuses);
    return React.createElement(Alert, { severity: 'info' }, t('shifts.pendingRequest.review.reviewVolunteers', { statuses: formattedStatuses }));
};
